module.exports = __webpack_public_path__ + "static/media/home-requsition.48d03d7b107cf254415fad0f4521522b.png";